module.exports = __webpack_public_path__ + "03_short_grey.94f9944e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_short_grey.png
// module id = Qer0
// module chunks = 0